/* global Tracking, preloadGist */
// Tracking & Gist buffer pattern
// Must load BEFORE application.js so that safeTrackGA / safePreloadGist
// are defined when inline calls in views execute.

(function() {
  window.TrackingBuffer = window.TrackingBuffer || [];
  let isTrackingReady = false;

  window.safeTrackGA = function(eventName, data) {
    if (typeof Tracking !== 'undefined' && isTrackingReady) {
      Tracking.trackGA(eventName, data);
    } else {
      window.TrackingBuffer.push({ eventName, data });
    }
  };

  window.addEventListener('TrackingReady', function() {
    isTrackingReady = true;
    window.TrackingBuffer.forEach(function(item) {
      if (typeof Tracking !== 'undefined') {
        Tracking.trackGA(item.eventName, item.data);
      }
    });
    window.TrackingBuffer = [];
  });

  setTimeout(function() {
    if (!isTrackingReady && typeof Tracking !== 'undefined') {
      window.dispatchEvent(new CustomEvent('TrackingReady'));
    }
  }, 5000);
})();

(function() {
  window.PreloadGistBuffer = window.PreloadGistBuffer || [];
  let isPreloadGistReady = false;

  window.safePreloadGist = function(workspaceId, delayToLoadGist) {
    if (typeof preloadGist !== 'undefined' && isPreloadGistReady) {
      preloadGist(workspaceId, delayToLoadGist);
    } else {
      window.PreloadGistBuffer.push({ workspaceId, delayToLoadGist });
    }
  };

  window.addEventListener('PreloadGistReady', function() {
    isPreloadGistReady = true;
    window.PreloadGistBuffer.forEach(function(item) {
      if (typeof preloadGist !== 'undefined') {
        preloadGist(item.workspaceId, item.delayToLoadGist);
      }
    });
    window.PreloadGistBuffer = [];
  });

  setTimeout(function() {
    if (!isPreloadGistReady && typeof preloadGist !== 'undefined') {
      window.dispatchEvent(new CustomEvent('PreloadGistReady'));
    }
  }, 5000);
})();
